import React from 'react';
import { Headline } from '@amount/frontend-components';

const ProductIdentifierHeadline: React.FC = props => (
  <Headline scale='small' as='h3'>
    {props.children}
  </Headline>
);

export default ProductIdentifierHeadline;
